enum Gender {
  Male,
  Female
}

export default Gender
